<div *ngIf="confirmed" style="display: flex; flex-direction: column; justify-content: center; align-items: center">
    <div>
        <img src="../../../../assets/images/success.png" alt="">
    </div>
    <p style="font-size: 22px; font-weight: 600; margin-bottom: 0; margin-top: 10px;">Profile Name</p>
    <p style="font-size: 22px; font-weight: 600; margin-top: 0; margin-bottom: 20px;">Successfully Updated!</p>
    <button vng-button variant="primary" (click)="close()" class="btn-block" style="height: 40x; margin-right: 10px; width: 170px;" type="submit">Continue</button>
</div>
<div *ngIf="!confirmed" style="display: flex; flex-direction: column; justify-content: center; align-items: center">
    <h2 style="color: #5F177F">Update Profile Name?</h2>
    <p style="color: #757575; margin: 0;">The name you entered is different from your profile name</p>
    <div style="display: flex; flex-direction: column; justify-content: flex-start">
        <div style="display: flex; justify-content: flex-start">
            <div style="background-color: #5F177F; height: 50px;">
                &nbsp;
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; flex: 1 1 100%; max-width: 100%; background-color: #F5F5F5; padding: 0 15px; height: 50px;">
                <p>Current profile name: &nbsp;</p> <b>{{user.user_details.first_name}}</b> &nbsp; <b>{{user.user_details.last_name}}</b>
            </div>
        </div>
        <div style="display: flex; justify-content: flex-start; margin-top: 10px;">
            <div style="background-color: #F0955C; height: 50px;">
                &nbsp;
            </div>
            <div style="display: flex; justify-content: flex-start; align-items: center; flex: 1 1 100%; max-width: 100%; background-color: #F5F5F5; padding: 0 15px; height: 50px;">
                <p>Update to: &nbsp;</p> <b>{{formValue.first_name || formValue.firstName}}</b> &nbsp; <b>{{formValue.last_name || formValue.lastName}}</b>
            </div>
        </div>
    </div>
    <div style="display: flex; justify-content: space-around; align-items: center; margin-top: 20px; width: 100%;">
        <button type="button" vng-button variant="secondary" style="width: 130px;" (click)="close()" tabindex="-1">
            Keep
        </button>
        <button vng-button variant="primary" (click)="update()" class="btn-block" style="height: 40x; margin-right: 10px; width: 130px;" type="submit" tabindex="-1">Update</button>
    </div>
</div>